/**
 * MIRAK product slider: horizontal scroll-snap row of product cards.
 * Prev/next buttons step by one card; native swipe/drag scrolling works
 * too. An IntersectionObserver finds whichever card is most visible and
 * drives the progress bar fill.
 */

const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

function initProductSlider(section) {
  const viewport = section.querySelector('[data-mirak-product-slider-viewport]');
  const slides = Array.from(section.querySelectorAll('[data-mirak-product-slider-slide]'));
  const progressFill = section.querySelector('[data-mirak-product-slider-progress]');
  const prevButton = section.querySelector('[data-mirak-product-slider-prev]');
  const nextButton = section.querySelector('[data-mirak-product-slider-next]');
  if (!viewport || !slides.length) return;

  const setProgress = (index) => {
    if (!progressFill) return;
    const fraction = (index + 1) / slides.length;
    progressFill.style.width = `${fraction * 100}%`;
  };

  let activeIndex = 0;

  const scrollToIndex = (index) => {
    const clamped = Math.max(0, Math.min(slides.length - 1, index));
    slides[clamped].scrollIntoView({
      behavior: reduceMotionQuery.matches ? 'auto' : 'smooth',
      inline: 'start',
      block: 'nearest',
    });
  };

  prevButton?.addEventListener('click', () => scrollToIndex(activeIndex - 1));
  nextButton?.addEventListener('click', () => scrollToIndex(activeIndex + 1));

  const activeObserver = new IntersectionObserver(
    (entries) => {
      let best = null;
      for (const entry of entries) {
        if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
      }
      if (best && best.intersectionRatio > 0) {
        activeIndex = slides.indexOf(best.target);
        setProgress(activeIndex);
      }
    },
    { root: viewport, threshold: [0.5, 0.75, 0.9, 1] },
  );

  slides.forEach((slide) => activeObserver.observe(slide));
  setProgress(0);
}

document.querySelectorAll('[data-mirak-product-slider-section]').forEach(initProductSlider);
